'use strict';

module.exports = function (response) {

  if (typeof axios !== 'undefined') return response.data;

  return response;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/get-response-data.js